(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mp-home-panel-hero"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-a"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-b"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-c"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-d"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-e"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-f"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-g"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-h"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-i"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-j"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-k"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-l"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-m"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-n"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-o"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-p"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-playground"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-page-campaign-q"]) return;
  try {
    
  jQuery(document).on('shopify:section:load', function(e){ 
    mp_lazyload_setup();
  });

  } catch(e) { console.error(e); }
})();
})();
